import type React from 'react';

import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { Button } from '@mui/material';
import { useTranslate } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

interface ButtonUploadProps {
  setValueOnUpload: (value: string) => void;
}

export default function ButtonUpload({ setValueOnUpload }: ButtonUploadProps): React.ReactElement {
  const translate = useTranslate();

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const files = event?.target?.files;
    flowchartLogger.debug('Uploading file:', files);
    if (files !== null) {
      const file = files[0];
      if (file === undefined) return;
      const reader = new FileReader();

      reader.onloadend = () => {
        flowchartLogger.debug('File uploaded:', reader.result);
        if (reader.result === null) return;
        if (typeof reader.result === 'string') {
          setValueOnUpload(reader.result);
        }
      };

      reader.readAsText(file);
    }
  };

  return (
    <label htmlFor='upload-image'>
      <Button variant='outlined' color='info' component='span'>
        <UploadFileRoundedIcon />
        {translate('callflows.interface.uploadFile')}
      </Button>
      <input id='upload-image' hidden accept='txt' type='file' onChange={handleFileUpload} />
    </label>
  );
}
